var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#272B32"}},[_c('iframe',{staticClass:"mx-auto",staticStyle:{"height":"94.5vh","width":"100%"},attrs:{"src":"https://statsinfo.co/live/1/","frameborder":"0"}})])
}]

export { render, staticRenderFns }